import { assign, find, map, union } from 'lodash';

import { RENTALOBJECT_TYPES } from '@/config/constants';
import dayjs from 'dayjs';
import { is } from '@vee-validate/rules';
import { mapGetters } from 'vuex';

export default {
  // implementera denna i varje arv.
  // då man man själv välja vart details ska komma ifrån
  // data(){
  //   return {
  //     _subscription : null
  //   }
  // },

  data() {
    return {
      showLoader: true,
      filters: {
        administrativeUnitTownDistricts: [],
        administrativeUnitAreas: [],
        rentalObjectTypes: [],
        maxRent: null,
        minArea: null,
        minRooms: null,
        maxRooms: null,
        waitingListType: [],
      },
    };
  },

  computed: {
    ...mapGetters(['config']),

    /**
     * Bostad, Fordonsplats eller Förråd
     */
    typeOfSubscription() {
      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT && !this.isStudentApartment)
        return 'Bostad';
      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT && this.isStudentApartment)
        return 'Studentbostad';
      if (this.objectType == RENTALOBJECT_TYPES.PARKING) return 'Fordonsplatser';
      if (this.objectType == RENTALOBJECT_TYPES.PREMISE) return 'Förråd';
      return;
    },

    /**
     * Bostad, Fordonsplats eller Förråd
     */
    urlFriendlyTypeOfSubscription() {
      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT && this.isStudentApartment)
        return 'studentbostader';
      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT) return 'bostad';
      if (this.objectType == RENTALOBJECT_TYPES.PARKING) return 'fordonsplatser';
      if (this.objectType == RENTALOBJECT_TYPES.PREMISE) return 'forrad';
      if (this.objectType == '????') return 'studentbostader';
      return;
    },

    isApartment() {
      return this.objectType === RENTALOBJECT_TYPES.APARTMENT;
    },
    isParking() {
      return this.objectType === RENTALOBJECT_TYPES.PARKING;
    },
    isPremise() {
      return this.objectType === RENTALOBJECT_TYPES.PREMISE;
    },

    /**
     * T.ex. 18-107912
     */
    code() {
      if (this._subscription) return this._subscription.code;
    },

    /**
     * T.ex. ["Central gävle"]
     */
    townDistricts() {
      if (!this._subscription) return [];
      //return this._subscription.administrativeUnitAreas.length > 0 ?  this._subscription.administrativeUnitAreas : this._subscription.administrativeUnitTownDistricts;
      return this._subscription.administrativeUnitAreas;
    },

    oldtownDistricts() {
      if (!this._subscription) return [];
      //return this._subscription.administrativeUnitAreas.length > 0 ?  this._subscription.administrativeUnitAreas : this._subscription.administrativeUnitTownDistricts;
      return this._subscription.administrativeUnitTownDistricts;
    },




    unitAreas() {
      if (!this._subscription) return [];
      return this._subscription.administrativeUnitAreas;
    },

    expiring() {
      if (!this._subscription) return false;
      var date = new Date();
      //show extend link if subscription expires within 14 days (mail reminder sent 11 days before)
      var expireDate = date.setDate(date.getDate() + 14);
      var waitingListDate = Date.parse(this._subscription.waitingListPeriodTo);

      return waitingListDate <= expireDate;
    },

    hasToMakeNew() {
      if (!this._subscription) return false;
      return (this._subscription.administrativeUnitTownDistricts.length > 0);
      /*let futureDate = "2025-09-01";

      return dayjs(this._subscription.expireDate).isBefore(futureDate, 'day');*/
    },

    extendDate() {
      if (!this._subscription) return false;
      //var date = new Date();
      var expireDate = this._subscription.waitingListPeriodTo; //date.setDate(date.getDate() + 90);
      return dayjs(expireDate).format('YYYY-MM-DD');
    },

    extendedDate() {
      if (!this._subscription) return false;
      var date = new Date();
      var expireDate = date.setDate(date.getDate() + 90);
      return dayjs(expireDate).format('YYYY-MM-DD');
    },

    searchCriteria() {
      return [
        ...this.townDistricts,
        ...(this.minRooms && this.maxRooms ? [`${this.minRooms} - ${this.maxRooms} rok`] : []),
        ...(this.minRooms && !this.maxRooms ? [`Minst ${this.minRooms} rok`] : []),
        ...(!this.minRooms && this.maxRooms ? [`Max ${this.maxRooms} rok`] : []),
        ...(this.minArea && this.maxArea ? [`${this.minArea} - ${this.maxArea} m\u00B2`] : []),
        ...(this.minArea && !this.maxArea ? [`Minst ${this.minArea} m\u00B2`] : []),
        ...(!this.minArea && this.maxArea ? [`Max ${this.minArea} m\u00B2`] : []),
        ...(this.maxRent ? [`Maxhyra ${this.maxRent} kr`] : []),
      ];
    },

    oldCriteria() {
      return [
        ...this.oldtownDistricts
      ];
    },

    enabled() {
      return this._subscription.enabled;
    },

    maxRent() {
      if (this._subscription) return this._subscription.maxRent;
    },

    minArea() {
      if (this._subscription) return this._subscription.minArea;
    },

    maxArea() {
      if (this._subscription) return this._subscription.maxArea;
    },

    minRooms() {
      if (this._subscription) return this._subscription.minRooms;
    },

    maxRooms() {
      if (this._subscription) return this._subscription.maxRooms;
    },

    waitingListType() {
      if (this._subscription && this._subscription.waitingListType)
        return this._subscription.waitingListType;

      return [];
    },

    waitingListPeriodTo() {
      if (this._subscription && this._subscription.waitingListPeriodTo)
        return this._subscription.waitingListPeriodTo;

      return '';
    },

    waitingListTypeCaption() {
      if (this._subscription && this._subscription.waitingListType)
        return this._subscription.waitingListType.map((t) => t.replace(/,.+/, ''));

      return [];
    },

    rentalObjectTypeTexts() {
      if (this._subscription.objectType === RENTALOBJECT_TYPES.APARTMENT) {
        return map(this._subscription.rentalObjectTypes, (subRentalObjectType) => {
          const type = find(this.config.rentalObjectTypes, (configRentalObjectTypes) => {
            return subRentalObjectType == configRentalObjectTypes.code;
          });

          if (type) return type.caption;
        });
      }

      if (this._subscription.objectType === RENTALOBJECT_TYPES.PARKING) {
        return map(this._subscription.rentalObjectTypes, (subRentalObjectType) => {
          const type = find(
            union(this.config.vehicleSpaceTypes, this.config.rentalObjectTypes),
            (configRentalObjectTypes) => {
              return subRentalObjectType == configRentalObjectTypes.code;
            },
          );

          if (type) return type.caption;
        });
      }

      return [];
    },

    /**
     * Tillfällig. Tills vi får rätt data från apit
     */
    objectType() {
      return this._subscription.objectType;
    },

    /**
     * /
     */
    url() {},

    isStudentApartment() {
      if (this._subscription && this._subscription.waitingListTypeCaption) {
        return !!this._subscription.waitingListTypeCaption.match('Prenumeration, student');
      }
      return false;
    },
  },
  methods: {
    activate() {
      this.showLoader = true;

      return this.$store.dispatch('activateSubscription', this.code).finally(() => {
        this.showLoader = false;
      });
    },

    extendSubscription() {
      this.showLoader = true;
      return this.$store.dispatch('extendSubscription', this._subscription).finally(() => {
        //this._subscription.waitingListPeriodTo = this._subscription.newWaitingListPeriod;
        this.$emit('done');
        this.showLoader = false;
      });
    },

    updateSubscription() {
      this.showLoader = true;
      let objectTypes = [];
      for (const [key, value] of Object.entries(this.filters.rentalObjectTypes)) {
        if (value == true) {
          objectTypes.push(key);
        } else if (value != '' && value != false && value != undefined) {
          objectTypes.push(value);
        }
      }

      let savedFilters = this.filters;
      savedFilters.rentalObjectTypes = objectTypes;
      return this.$store
        .dispatch('updateSubscription', assign(this._subscription, savedFilters))
        .finally(() => {
          this.showLoader = false;
        });
    },

    addSubscription() {
      const type = !this.selectedObjectType.match(/s$/)
        ? this.selectedObjectType + 's'
        : this.selectedObjectType;
      return this.$store.dispatch('createSubscription', {
        subscription: {
          ...this.filters,
          "administrativeUnitTownDistricts": null,
          "administrativeUnitDistricts": null,
          "minRent": null
        },

        /**
         * Är det en bevakning på lägenheter, parkering eller förråd.
         */
        type,
      });
    },

    deleteSubscription() {
      this.showLoader = true;

      return this.$store
        .dispatch('deleteSubscription', this.code)
        .then((result) => {
          this.showLoader = false;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },

    rentalCodeToText: function (codes, model) {
      var ret = [];
      for (var i = 0; i < codes.length; i++) {
        for (var u = 0; u < model.length; u++) {
          if (codes[i].rentalObjectType === model[u]) {
            ret.push(codes[i].caption);
            break;
          }
        }
      }
      return ret;
    },
  },
};
